import moment from 'moment';

import * as storage from '@elab/core/utils/session';

/**
 * @param { Array } activeFilters - array of active filters
 * @param { Boolean } isMultiple - flag for multiple filters
 * @returns { String } string with active filters
 */
export const getActiveFilters = (activeFilters = [], isMultiple = false) => {
    if (!activeFilters.length) return '';

    if (isMultiple) {
        const filters = activeFilters.reduce((filtersList, filter) => {
            const type = filter.filterType;
            if (!filtersList[type]) {
                filtersList[type] = '';
            } else {
                filtersList[type] += ';';
            }
            filtersList[type] += filter.value;
            return filtersList;
        }, {});

        const params = Object.entries(filters).reduce((str, [p, val], index) => {
            return `${str}${p}:${val}${index !== Object.keys(filters).length - 1 ? ',' : ''}`;
        }, '');

        return params;
    }

    return activeFilters.length > 1
        ? activeFilters.map(filter => filter.value).join(',')
        : activeFilters[0].value;
};

export const mapReviews = (reviews, dateFormat) =>
    reviews.map(({ alias, principal = {}, date, feedbacks = [], ...rest }) => ({
        ...rest,
        userName: alias || principal.name,
        date: dateFormat ? moment(date).format(dateFormat) : date,
        feedbacks:
            feedbacks.length &&
            feedbacks.map(({ created, ...rest }) => ({
                ...rest,
                created: dateFormat ? moment(created).format(dateFormat) : created,
            })),
    }));

export const saveReportedReview = id => {
    const reviews = getReportedReviews();
    reviews.push(id);
    storage.set(storage.key.reportedReviews, reviews);
};

export const getReportedReviews = () => {
    return storage.get(storage.key.reportedReviews, true) || [];
};
